import React from 'react';
import { oneOfType, string, number } from 'prop-types';
import CurrencyFormat from 'react-currency-format';
import { isNumber } from 'lodash';

const Currency = ({
  value,
  decimals = 2,
  displayType,
  className,
  placeholder,
  onValueChange,
  isAllowed,
  onChange,
  disabled,
  onBlur,
}) => {
  const formattedValue = (() => {
    if (!value) {
      return '';
    }
    if (isNumber(value)) {
      return value.toFixed();
    }
    return value.toString().split('.')[0];
  })();
  return (
  <CurrencyFormat
    value={formattedValue}
    thousandSeparator
    prefix="$"
    displayType={displayType || 'text'}
    decimalScale={decimals}
    fixedDecimalScale={false}
    className={className}
    placeholder={placeholder}
    onValueChange={onValueChange}
    isAllowed={isAllowed}
    onChange={onChange}
    disabled={disabled}
    onBlur={onBlur}
  />
  )
};
Currency.propTypes = {
  value: oneOfType([number, string]),
};
Currency.defaultProps = {
  isAllowed: () => true,
  onBlur: () => {},
};
export default Currency;
